import React from 'react';
import { TextParagraph } from '../Typography/TextBody';

import './GDPRConsentText.less';

export const GDPRConsentText = () => {
  return (
    <div className="consentText">
      <TextParagraph>
        Letters by Liaison collects and processes personal information about you when you act as a Recommender through
        this service. This Privacy Notice explains how we use your personal information. If you have any questions,
        please refer to{' '}
        <a href="https://www.liaisonedu.com/privacy-policy/" target="_blank" rel="noreferrer">
          https://www.liaisonedu.com/privacy-policy/
        </a>
      </TextParagraph>
      <br />
      <TextParagraph>
        <div>
          <u>Why we collect your personal information</u>
        </div>
        We need your personal information to allow us and organizations to which the relevant applicant(s) is applying
        to contact you in connection with the application and to assess your recommendation and the applicant’s
        suitability for admission.
      </TextParagraph>
      <br />

      <TextParagraph>
        We may sometimes need to use your personal information for other purposes, including protecting our legitimate
        interests in maintaining the integrity of our service. You can find details of how we handle personal
        information at{' '}
        <a href="https://www.liaisonedu.com/privacy-policy/" target="_blank" rel="noreferrer">
          https://www.liaisonedu.com/privacy-policy/
        </a>
        . For more information on how downstream organizations use your information, please contact the organizations to
        which the relevant applicant(s) is applying.
      </TextParagraph>
      <br />

      <TextParagraph>
        <div>
          <u>How we share your personal information</u>
        </div>
        We are based in the United States of America. Any personal information you provide is transmitted to, and stored
        in, the USA. We also transfer your personal information to:
        <ol>
          <li>
            <u>Designated Schools and Organizations</u>. These organizations are based in a variety of countries; when
            the relevant applicant applies to an organization in one of those countries, your data will be transferred
            to the organization there.
          </li>
          <li>
            <u>Third party service providers</u>. We engage third parties, including our web hosting provider, to help
            us provide this service. We may also share aggregated and anonymized data derived from your personal
            information with third parties for research or statistical purposes.
          </li>
        </ol>
        You can find additional information on how we share your personal information at{' '}
        <a href="https://www.liaisonedu.com/privacy-policy/" target="_blank" rel="noreferrer">
          https://www.liaisonedu.com/privacy-policy/
        </a>
      </TextParagraph>
      <br />

      <TextParagraph>
        <div>
          <u>How long do we keep your personal information</u>
        </div>
        We keep your personal information for as long as it is necessary to provide the applicant with this service or
        we have another legitimate reason to retain it. You can find more information about how long we keep your
        personal information at{' '}
        <a href="https://www.liaisonedu.com/privacy-policy/" target="_blank" rel="noreferrer">
          https://www.liaisonedu.com/privacy-policy/
        </a>
      </TextParagraph>
      <br />

      <TextParagraph>
        <div>
          <u>Your rights</u>
        </div>
        If you are based in the European Union, Iceland, Liechtenstein, Norway, or Switzerland, you have certain rights
        with respect to your personal information. These include the right to receive a copy of it and to require us to
        erase it in certain circumstances. You also have the right to raise any concerns or complaints with the data
        protection Supervisory Authority in your country. You can find additional information about your rights at{' '}
        <a href="https://www.liaisonedu.com/privacy-policy/" target="_blank" rel="noreferrer">
          https://www.liaisonedu.com/privacy-policy/
        </a>{' '}
        and{' '}
        <a href="https://www.liaisonedu.com/gdpr-faq/" target="_blank" rel="noreferrer">
          https://www.liaisonedu.com/gdpr-faq/
        </a>
        . Please contact us at <a href="mailto:contact@liaisonedu.com">contact@liaisonedu.com</a> if you wish to discuss
        your rights.
      </TextParagraph>
      <br />
    </div>
  );
};

export default GDPRConsentText;
